import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tooltip from 'flarum/common/components/Tooltip';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import LangDisplayName from '../../common/utils/LangDisplayName';
import TranslationMeta from './TranslationMeta';
/**
 * Translated content under the original: header with close/refresh, body, meta footer.
 */
export default class TranslationBlock extends Component {
  view() {
    const {
      state,
      className
    } = this.attrs;
    if (!state.showing) return null;
    const current = state.active();
    return m("section", {
      className: classList('TranslationBlock', className, state.loading && 'TranslationBlock--loading'),
      lang: state.language ?? undefined
    }, m("header", {
      className: "TranslationBlock-header"
    }, m("span", {
      className: "TranslationBlock-title"
    }, this.title(current)), m("ul", {
      className: "TranslationBlock-controls"
    }, this.controlItems().toArray().map(item => m("li", null, item)))), current ? m("div", {
      className: "TranslationBlock-body"
    }, this.attrs.body(current)) : m(LoadingIndicator, {
      display: "block",
      size: "small"
    }), current && m("footer", {
      className: "TranslationBlock-footer"
    }, m(TranslationMeta, {
      provider: current.provider(),
      updatedAt: current.updatedAt()
    })));
  }
  title(translation) {
    const {
      state
    } = this.attrs;
    const source = translation?.sourceLanguage() || this.attrs.source;
    const to = LangDisplayName(state.language ?? '');
    if (state.loading && !translation) {
      return app.translator.trans('fof-translate.forum.translation.loading_text', {
        to
      });
    }
    return source ? app.translator.trans('fof-translate.forum.translation.header_from', {
      from: LangDisplayName(source),
      to
    }) : app.translator.trans('fof-translate.forum.translation.header_to', {
      to
    });
  }
  controlItems() {
    const items = new ItemList();
    const {
      state
    } = this.attrs;
    if (app.forum.attribute('fof-translate.canRefresh') && state.translation) {
      const label = extractText(app.translator.trans('fof-translate.forum.translation.refresh_button'));
      items.add('refresh', m(Tooltip, {
        text: label
      }, m(Button, {
        className: "Button Button--icon Button--link TranslationBlock-refresh",
        icon: "fas fa-sync",
        "aria-label": label,
        loading: state.loading,
        disabled: state.loading,
        onclick: () => state.refresh()
      })), 10);
    }
    const closeLabel = extractText(app.translator.trans('fof-translate.forum.translation.close_button'));
    items.add('close', m(Tooltip, {
      text: closeLabel
    }, m(Button, {
      className: "Button Button--icon Button--link TranslationBlock-close",
      icon: "fas fa-times",
      "aria-label": closeLabel,
      onclick: () => state.close()
    })), 0);
    return items;
  }
}
flarum.reg.add('fof-translate', 'forum/components/TranslationBlock', TranslationBlock);